import { graphql, useStaticQuery } from "gatsby"

export const useQuizData = () => {
    const data = useStaticQuery(
        graphql`
            query {
                meta: allTestQuiz1Csv(
                    filter: { meta: { name: { ne: null } } }
                ) {
                    nodes {
                        meta {
                            date
                            name
                            metaTitle
                            metaDescription
                            styles {
                                darkerColor
                                lighterColor
                            }
                            text
                            type
                            shareText
                        }
                    }
                }
                questions: allTestQuiz1Csv(
                    filter: { questions: { question: { ne: null } } }
                ) {
                    nodes {
                        questions {
                            number
                            adNumber
                            question
                            question_id
                            bonus
                            option1 {
                                label
                                results
                            }
                            option2 {
                                label
                                results
                            }
                            option3 {
                                label
                                results
                            }
                            option4 {
                                label
                                results
                            }
                        }
                    }
                }
                results: allTestQuiz1Csv(
                    filter: { results: { result: { ne: null } } }
                ) {
                    nodes {
                        results {
                            result
                        }
                        fields {
                            result_slug
                        }
                    }
                }
            }
        `
    )
    return data
}
